<template>
	<div>
		<b-row>
			<b-col md="12" class="mb-4">
				<h6>Null</h6>
				<document-type-selectbox v-model="value1"/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Single Selected</h6>
				<document-type-selectbox v-model="value2"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<document-type-selectbox v-model="value3" :validate-error="value3ValidateError"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change') }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import DocumentTypeSelectbox from "@/components/interactive-fields/DocumentTypeSelectbox";

	export default {
		components: {
			DocumentTypeSelectbox,
		},
		data() {
			return {
				value1: null,
				value2: 'transkript',
				value3: 'transkript',
				value3ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value2 = 'student-certificate'
				this.value3 = 'student-certificate'
				this.value3ValidateError = 'Error'
			}
		}
	};
</script>

